import React from "react";
import styled from "styled-components/macro";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors } from "theme/Theme";
import { TableRowData } from "./types";

interface MainSpecsProps {
  title: string;
  data: TableRowData[];
}

const CommonTable: React.FC<MainSpecsProps> = ({ title, data }) => {
  return (
    <TableContainer style={{ width: "100%" }} component={Paper}>
      <Table size="small" aria-label="main-tech-specs-table">
        <StyledTableHead>
          <TableRow>
            <TableCell align="center" colSpan={2}>
              {title}
            </TableCell>
          </TableRow>
        </StyledTableHead>
        <TableBody>
          {data.map((item: any, idx: any) => {
            return (
              item.value && (
                <StyledTableRow key={idx}>
                  <TableCell>{item.key}</TableCell>
                  <TableCell>{item.value}</TableCell>
                </StyledTableRow>
              )
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const StyledTableHead = styled(TableHead)`
  background-color: ${colors.dark};

  th {
    font-weight: 600;
    color: white;
  }
`;

const StyledTableRow = styled(TableRow)`
  &:nth-of-type(even) {
    background-color: ${colors.lightest_blue};
  }

  td {
    padding: 6px 10px;
  }
`;

export default CommonTable;
